/* Outdoors Nordic. Flyttad ur blocks/on-size-guide.liquid 2026-10-07, och pa
   nytt 2026-10-13 fran snabbfixens version vid sammanslagningen med LIVE (punkt 16).
   Lag inline och skickades med varje sidvisning som anvande sektionen.
   Laddas som modul: samma URL evalueras en gang oavsett antal taggar. */

  (function () {
    if (customElements.get('on-size-guide')) return;

    function maxNum(s) {
      var m = (s || '').match(/\d+([.,]\d+)?/g);
      if (!m) return NaN;
      var max = -Infinity;
      m.forEach(function (x) { var n = parseFloat(x.replace(',', '.')); if (n > max) max = n; });
      return max;
    }
    function toInch(s) {
      return String(s).replace(/\d+([.,]\d+)?/g, function (m) {
        return (parseFloat(m.replace(',', '.')) * 0.3937).toFixed(1);
      });
    }

    class OnSizeGuide extends HTMLElement {
      connectedCallback() {
        if (this._sgReady) return;
        /* Kopbox-guiden (Integrerad) ar bara reserv. Finns ett separat guideblock med
           knapp pa samma sida tas reserven bort, sa att guiden bara finns en gang.
           Servern gor samma sak nar bada ligger i samma kolumn. */
        if (this.hasAttribute('data-sg-embedded')) {
          var egen = document.querySelector('on-size-guide:not([data-sg-embedded]) [data-sg-open]');
          if (egen) { var omslag = this.closest('.on-kb-sg') || this; omslag.remove(); return; }
        }
        this._sgReady = true;
        this.dialog = this.querySelector('.on-sg__dialog');
        var openBtn = this.querySelector('[data-sg-open]');
        var self = this;

        this.unit = this.getAttribute('data-default-unit') || 'cm';
        this.cmLabel = this.getAttribute('data-cm-label') || 'cm';
        this.inLabel = this.getAttribute('data-in-label') || 'in';

        if (openBtn && this.dialog) {
          openBtn.addEventListener('click', function () {
            if (typeof self.dialog.showModal === 'function') self.dialog.showModal();
            else self.dialog.setAttribute('open', '');
            self.fitTable();
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
          });
        }
        if (this.dialog) {
          this.dialog.addEventListener('close', function () {
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
          });
          this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.close(); });
        }
        this.querySelectorAll('[data-sg-close]').forEach(function (b) {
          b.addEventListener('click', function () { self.close(); });
        });

        var fitTimer = null;
        window.addEventListener('resize', function () {
          clearTimeout(fitTimer);
          fitTimer = setTimeout(function () { self.fitTable(); }, 150);
        });

        this.buildCalc();
        this.querySelectorAll('[data-sg-unit]').forEach(function (btn) {
          btn.addEventListener('click', function () { self.unit = btn.getAttribute('data-sg-unit'); self.applyUnit(); });
        });
        this.applyUnit();

        var go = this.querySelector('[data-calc-go]');
        if (go) go.addEventListener('click', function () { self.calculate(); });
        // Räkna om direkt när ett mått ändras/rättas (delegerat, överlever ombyggnad av fälten)
        var fieldsWrap = this.querySelector('[data-calc-fields]');
        if (fieldsWrap) fieldsWrap.addEventListener('input', function () { self.calculate(); });
      }

      /* Alla kolumner ska alltid synas (omgang 29). Far tabellen plats ser den ut som forut.
         Gor den inte det radbryts rubrikerna forst (enheten pa egen rad, tatare celler),
         och racker inte det skrollar tabellen i sidled med forsta kolumnen fast.
         Mats bara nar guiden ar oppen, vid enhetsbyte och vid storleksandring. */
      fitTable() {
        var wrap = this.querySelector('.on-sg__tablewrap');
        var t = wrap && wrap.querySelector('.on-sg__table');
        if (!t || !this.dialog || !this.dialog.open) return;
        wrap.classList.remove('is-tight', 'is-short', 'is-compact', 'is-scroll');
        this.setShort(wrap, false);
        if (t.scrollWidth <= wrap.clientWidth) return;
        wrap.classList.add('is-tight');
        if (t.scrollWidth <= wrap.clientWidth) return;
        /* Omgång 60: korta rubriker (fulla namnet i fotnoten), sedan 10 px text och tätare
           celler. Sidledsskroll bara om inget av det räcker. */
        this.setShort(wrap, true);
        wrap.classList.add('is-short');
        if (t.scrollWidth <= wrap.clientWidth) return;
        wrap.classList.add('is-compact');
        if (t.scrollWidth <= wrap.clientWidth) return;
        wrap.classList.add('is-scroll');
      }

      setShort(wrap, on) {
        var ths = wrap.querySelectorAll('th[data-short]');
        var par = [];
        for (var i = 0; i < ths.length; i++) {
          var th = ths[i];
          if (th.getAttribute('data-full') == null) th.setAttribute('data-full', th.textContent);
          var full = th.getAttribute('data-full'), kort = th.getAttribute('data-short');
          th.textContent = on ? kort : full;
          if (on) par.push(kort + ' = ' + full);
        }
        var fot = this.querySelector('[data-sg-abbr]');
        if (fot) { fot.textContent = par.join(' · '); fot.hidden = !par.length; }
      }

      close() {
        if (!this.dialog) return;
        if (typeof this.dialog.close === 'function') this.dialog.close();
        else { this.dialog.removeAttribute('open'); document.documentElement.style.overflow = ''; document.body.style.overflow = ''; }
      }

      buildCalc() {
        var wrap = this.querySelector('[data-calc-fields]');
        var table = this.querySelector('.on-sg__table');
        if (!wrap || !table) return;
        var self = this;

        var ths = table.querySelectorAll('thead th');
        this.measureCols = [];
        for (var i = 0; i < ths.length; i++) {
          if (ths[i].hasAttribute('data-measure')) {
            this.measureCols.push({
              idx: i,
              label: (ths[i].getAttribute('data-head') || ths[i].textContent).trim(),
              // Midjekolumnen har ett utsträckt mått bakom sig (dolt ur tabellen).
              hasStretch: ths[i].hasAttribute('data-has-stretch')
            });
          }
        }

        this.calcRows = [];
        table.querySelectorAll('tbody tr').forEach(function (tr) {
          var cells = tr.children;
          var size = cells[0] ? cells[0].textContent.trim() : '';
          var vals = {};
          self.measureCols.forEach(function (mc) {
            var cell = cells[mc.idx];
            vals[mc.idx] = cell ? maxNum(cell.getAttribute('data-cm') || cell.textContent) : NaN;
          });
          // Utsträckt midja i cm – ligger på raden, inte som kolumn (se Liquid ovan).
          var st = maxNum(tr.getAttribute('data-stretch') || '');
          self.calcRows.push({ size: size, vals: vals, stretch: st });
        });

        if (!this.measureCols.length || !this.calcRows.length) return;

        var desired = (this.getAttribute('data-calc-cols') || '').split('|')
          .map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
        var selected = [];
        desired.forEach(function (name) {
          if (selected.length >= 2) return;
          var mc = self.measureCols.find(function (m) { return m.label.toLowerCase() === name; });
          if (mc && selected.indexOf(mc) === -1) selected.push(mc);
        });
        if (!selected.length) selected = this.measureCols.slice(0, 2);
        this.calcSel = selected.slice(0, 2);

        // Bygg fälten bara om de inte redan finns → bevarar användarens inmatade mått
        if (!wrap.children.length) {
          var u = this.unit === 'in' ? this.inLabel : this.cmLabel;
          wrap.innerHTML = this.calcSel.map(function (mc) {
            return '<label class="on-sg__finder-field"><span>' + mc.label + ' (<span data-calc-unit>' + u + '</span>)</span>' +
                   '<input type="number" inputmode="decimal" min="0" step="0.1" data-colidx="' + mc.idx + '" placeholder="' + u + '"></label>';
          }).join('');
        }
      }

      applyUnit() {
        var self = this, isIn = this.unit === 'in';
        this.querySelectorAll('[data-sg-unit]').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-sg-unit') === self.unit);
        });
        this.querySelectorAll('.on-sg__table td[data-cm]').forEach(function (td) {
          var cm = td.getAttribute('data-cm');
          td.textContent = isIn ? toInch(cm) : cm;
        });
        /* Alla kolumnrubriker, inte bara den forsta: forut stod "(cm)" kvar i resten i tumlaget. */
        var self2 = this;
        this.querySelectorAll('[data-unit-note]').forEach(function (note) {
          note.textContent = '(' + (isIn ? self2.inLabel : self2.cmLabel) + ')';
        });
        this.fitTable();
        var u = isIn ? this.inLabel : this.cmLabel;
        this.querySelectorAll('[data-calc-unit]').forEach(function (el) { el.textContent = u; });
        this.querySelectorAll('.on-sg__finder-field input').forEach(function (inp) { inp.placeholder = u; });
      }

      calculate() {
        if (!this.calcSel || !this.calcRows || !this.calcRows.length) return;
        var self = this, maxIdx = -1, any = false, isIn = this.unit === 'in', tooBig = false;
        this.calcSel.forEach(function (mc) {
          var inp = self.querySelector('input[data-colidx="' + mc.idx + '"]');
          if (!inp) return;
          var v = parseFloat((inp.value || '').replace(',', '.'));
          if (isNaN(v)) return;
          if (isIn) v = v / 0.3937;
          any = true;
          var found = -1;
          for (var r = 0; r < self.calcRows.length; r++) {
            var cv = self.calcRows[r].vals[mc.idx];
            if (!isNaN(cv) && cv >= v) { found = r; break; }
          }
          // Utsträckt midja används BARA som tak, aldrig för att föreslå en mindre
          // storlek. Att peka på den minsta storlek vars stretchade midja "täcker"
          // måttet vore dåligt råd: ett plagg buret vid sin yttersta töjning sitter
          // inte bra. Ligger måttet över även största storlekens utsträckta midja
          // finns ingen storlek som passar – då säger vi hellre ingenting än fel.
          if (found === -1 && mc.hasStretch) {
            var lastRow = self.calcRows[self.calcRows.length - 1];
            var lastStretch = lastRow ? lastRow.stretch : NaN;
            if (!isNaN(lastStretch) && v > lastStretch) { tooBig = true; }
          }
          if (found === -1) found = self.calcRows.length - 1;
          if (found > maxIdx) maxIdx = found;
        });
        var res = this.querySelector('[data-calc-result]');
        var val = this.querySelector('[data-calc-val]');
        // Ryms inte ens i största storlekens utsträckta midja → visa ingen storlek.
        // Att peka ut 6XL åt någon den inte passar skapar bara en retur.
        if (!any || maxIdx < 0 || tooBig) { if (res) res.hidden = true; return; }
        if (val) val.textContent = this.calcRows[maxIdx].size;
        if (res) res.hidden = false;
      }
    }

    customElements.define('on-size-guide', OnSizeGuide);
  })();
